import { EditRecruitmentProvider } from './Contexts/EditRecruitmentContext';
import EditRecruitmentPageContent from './EditRecruitmentPageContent';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import withGooglePlacesAPICheck from '@/Routing/withGooglePlacesAPICheck';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

const EditRecruitmentPage = () => {
    return (
        <EditRecruitmentProvider>
            <EditRecruitmentPageContent />
        </EditRecruitmentProvider>
    );
};

export default withCompanyProfileRequired(
    withTalentMeshUserRequired(withSignupChecks(withGooglePlacesAPICheck(EditRecruitmentPage))),
);
